import { Typography } from '@execonline-inc/execonline-ui';
import * as React from 'react';
import { emptyFragment } from '../../../../../EmptyFragment';
import { T } from '../../../../../Translations';
import { foldInviteTarget, inviteTarget } from '../InviteTarget';
import { shareStore } from '../Stores/ShareStore';

const CollectionHeader: React.FC = () => {
  return (
    <>
      {inviteTarget(shareStore.state)
        .map((target) => (
          <div
            key={target.kind}
            className="bg-primary/10 border-y border-border px-8 py-3"
            data-intercom-target="participant-search-inviting-to"
          >
            <Typography variant="bodyMedium">
              <T kind="Inviting to" />{' '}
              <span className="font-semibold text-primary">
                {foldInviteTarget(
                  target,
                  (c) => c.collectionName,
                  (c) => c.courseName.getOrElseValue(c.collectionName),
                )}
                .
              </span>
            </Typography>
          </div>
        ))
        .getOrElseValue(emptyFragment())}
    </>
  );
};

export default CollectionHeader;
